module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_ass.ddc6241b.mp3";